import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Typography,
  Stack,
} from "@mui/material";
import { FilterList, Clear, Search } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { selectAuditLogFilters } from "../../../store/slices/auditLogSlice";

const AuditLogAdvancedFilters = ({ onApplyFilters }) => {
  const dispatch = useDispatch();
  const currentFilters = useSelector(selectAuditLogFilters);
  
  const [filters, setFilters] = useState({
    chitalishteId: "",
    feedbackId: "",
    entityType: "",
    action: "",
    performedBy: "",
    startDate: "",
    endDate: "",
  });

  // Синхронизираме local state с Redux state при промяна
  useEffect(() => {
    setFilters(currentFilters);
  }, [currentFilters]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleApplyFilters = () => {
    // Преобразуване на филтрите в правилен формат
    const formattedFilters = {};
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        formattedFilters[key] = value;
      }
    });

    onApplyFilters(formattedFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      chitalishteId: "",
      feedbackId: "",
      entityType: "",
      action: "",
      performedBy: "",
      startDate: "",
      endDate: "",
    };
    
    setFilters(clearedFilters);
    onApplyFilters(clearedFilters);
  };

  // Форматиране на датата за input field
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    } catch (e) {
      return dateString;
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 2 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <FilterList color="primary" />
        <Typography variant="h6">Разширени филтри</Typography>
      </Stack>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth size="small">
            <InputLabel>Тип действие</InputLabel>
            <Select
              value={filters.action || ""}
              onChange={(e) => handleFilterChange("action", e.target.value)}
              label="Тип действие"
            >
              <MenuItem value="">Всички действия</MenuItem>
              <MenuItem value="CREATE">Създаване</MenuItem>
              <MenuItem value="UPDATE">Редактиране</MenuItem>
              <MenuItem value="DELETE">Изтриване</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth size="small">
            <InputLabel>Тип обект</InputLabel>
            <Select
              value={filters.entityType || ""}
              onChange={(e) => handleFilterChange("entityType", e.target.value)}
              label="Тип обект"
            >
              <MenuItem value="">Всички обекти</MenuItem>
              <MenuItem value="CHITALISHTE">Читалище</MenuItem>
              <MenuItem value="INFORMATION_CARD">Информационна карта</MenuItem>
              <MenuItem value="USER">Потребител</MenuItem>
              <MenuItem value="FEEDBACK">Обратна връзка</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            size="small"
            label="Извършител"
            value={filters.performedBy || ""}
            onChange={(e) => handleFilterChange("performedBy", e.target.value)}
            placeholder="Въведете име на потребител"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            size="small"
            label="ID на читалище"
            value={filters.chitalishteId || ""}
            onChange={(e) => handleFilterChange("chitalishteId", e.target.value)}
            placeholder="Напр. 123"
            type="number"
            InputProps={{ inputProps: { min: 0 } }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            size="small"
            label="ID на обратна връзка"
            value={filters.feedbackId || ""}
            onChange={(e) => handleFilterChange("feedbackId", e.target.value)}
            placeholder="UUID формат"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            size="small"
            label="От дата"
            type="date"
            value={formatDateForInput(filters.startDate)}
            onChange={(e) => handleFilterChange("startDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            size="small"
            label="До дата"
            type="date"
            value={formatDateForInput(filters.endDate)}
            onChange={(e) => handleFilterChange("endDate", e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="outlined"
              startIcon={<Clear />}
              onClick={handleClearFilters}
            >
              Изчисти филтри
            </Button>
            <Button
              variant="contained"
              startIcon={<Search />}
              onClick={handleApplyFilters}
            >
              Приложи филтри
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AuditLogAdvancedFilters;